import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material"
import React, { FC } from "react"

interface IProps {
  open: boolean
  title?: string | React.ReactNode
  content: string | React.ReactNode
  cancelText?: string
  actions?: React.ReactNode
  onClose?: () => void
}
const MyDialog: FC<IProps> = (props) => {
  return (
    <Dialog open={props.open}>
      {props.title && <DialogTitle>{props.title}</DialogTitle>}

      <DialogContent>{props.content}</DialogContent>
      <DialogActions>
        {props.actions && props.actions}
        {!props.actions && (
          <Button className="btn" variant="contained" onClick={props?.onClose}>
            {props.cancelText || "Cancel"}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}

export default MyDialog
